module.exports = __webpack_public_path__ + "img/mavic_mini_728_90.88d1064e.jpg";